import { Trans } from '@lingui/macro'
import React, { FC, useEffect, useState } from 'react'

import { BlogResponse } from '../../api/feed'
import { BlogItem } from '../../interfaces'
import { sanitizeHtml } from '../../utils/xss'
import BreadcrumbBar from '../bars/BreadcrumbBar'
import ChannelBlog from '../ChannelBlog'
import ChannelQuestion from '../ChannelQuestion'
import Footer from '../Footer'
import Header from '../Header'
import { Eye } from '../icons'
import { CustomisedFeedObjectQuestion } from '../NewQuestion'
import styles from './BlogPage.module.css'

interface Props {
  blogDetails: BlogResponse
  blogDataList: Array<BlogItem>
  qaDataList: Array<CustomisedFeedObjectQuestion>
}
const hideCrumbBar = new Set(['ALL'])

//To reduced the View count to 5000, 'EXERCISE' we are using as an identifier
const getInitialCount = (data?: string[]) => (data?.includes('EXERCISE') ? 5000 : 75000)

const BlogPage: FC<Props> = props => {
  const [viewCount, setViewCount] = useState(0)
  const id = props.blogDetails.payload?.id
  const categories = props.blogDetails.payload?.categories
  useEffect(() => {
    if (id) {
      const last5Digits = getInitialCount(categories) + (parseInt(id, 10) % 1000)
      setViewCount(Math.round(1.04 * last5Digits))
    }
  }, [id, categories])

  return (
    <>
      <Header />
      <div className={styles.contentWrapper} style={{}}>
        {' '}
        {/*Mobile view */}
        <BreadcrumbBar hide={hideCrumbBar} className={styles.breadCrumbBar} />
        <div className={styles.contributerTitle}> {props?.blogDetails?.payload?.title}</div>
        <div className={styles.imageWrapper}>
          <img src={props.blogDetails.payload?.imageUrl} alt='' />
        </div>
      </div>
      <div className={styles.contributerWrapper}>
        <div className={styles.contributerWrapperTitle}>
          <Trans>This post was contributed by:</Trans>
        </div>
        <div className={styles.authorDetailWrapper}>
          <div className={styles.authorImage}>
            <img alt='Dr Sumaiya' src='https://p.healofy.net/web/dr-blog.png' className={styles.profilePic} />
          </div>
          <div>
            <div className={styles.contributerUserName}> Dr. Sumaiya</div>
            <div className={styles.contributerUserTitle}>
              <Trans>Healofy Expert Doctor</Trans>
              {viewCount ? (
                <span className={styles.views}>
                  <Eye />
                  <span>&nbsp;&nbsp;</span>
                  {viewCount}
                </span>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.content} dangerouslySetInnerHTML={{ __html: sanitizeHtml(props.blogDetails.payload?.content || '') }} />
      {props.qaDataList?.length ? <ChannelQuestion data={props.qaDataList} /> : null}
      {props.blogDataList?.length ? <ChannelBlog data={props.blogDataList} /> : null}
      <Footer />
    </>
  )
}

export default BlogPage
